export const COMPANY_DEFAULTS = {
  companyName: "CÔNG TY CỔ PHẦN THƯƠNG MẠI DỊCH VỤ CIS",
  companyOffice: "văn phòng Công Ty Cổ phần Thương Mại Dịch vụ CIS",
  companyAddress: "Tầng 6, số 96 Nguyễn Đình Hoàn, Phường Nghĩa Đô, Quận Cầu Giấy, Thành phố Hà Nội, Việt Nam.",
  companyTax: "0110948453",
  representative: "Phạm Thị Thu Lan",
  repIdNumber: "034189014297",
  repIdDate: "09/08/2021",
  repTitle: "Giám đốc",
  certificate: "0110948453",
  dateIssued: "04/02/2025",
  issuingAuthority: "Phòng ĐKKD Sở Kế hoạch và Đầu tư Thành phố Hà Nội",
  phone: "0976567778"
};
